export default {
  login: '/api/auth/login',
  logout: '/api/auth/logout',
  check_login: '/api/auth/check-login',
  change_password: '/api/auth/change-password',
  forgot_password: '/api/auth/forgot-password',
  reset_password: '/api/auth/reset-password',
  programari: '/api/bookings',
  comenzi: '/api/comenzi',
  uploads: '/uploads',
  invoice: '/api/invoice',
  invoice_smartbill: '/api/invoice-smartbill',
  invoice_smartbill_bulk: '/api/invoice-smartbill-bulk',
  invoice_oblio: '/api/invoice-oblio',
  invoices: '/api/invoices',
  devize: '/api/devize',
  raport_lunar_pdf: '/api/raport-lunar-pdf',
  comanda_noua: '/api/comenzi',
  update_comanda: '/api/comenzi/update',
  save_formular_comanda: '/api/comenzi/save-formular-comanda',
  save_deviz: '/api/comenzi/save-deviz',
  save_deviz_custom: '/api/comenzi/save-deviz-custom',
  download_pdf_custom: '/api/download-pdf-custom',
  download_pdf_custom_2: '/api/download-pdf-custom-2',
  get_clienti: '/api/clienti',
  scan_id_card: '/api/clienti/scan-id-card',
  templates: '/api/templates',
  intrari_by_date_range: '/api/comenzi/get-intrari-by-date-range',
  deviz: '/api/deviz',
  cars: '/api/cars',
  links: '/api/links',
  scan_talon: '/api/scan-talon',
  lookup_cui: '/api/companies/lookup-cui',
  setari_rar: '/api/setari/rar',
  rar_login: '/api/rar/login',
  setari_haynes: '/api/setari/haynes',
  setari_logo: '/api/setari/logo',
  setari_watermark: '/api/setari/watermark',
  setari_smartbill: '/api/setari/smartbill',
  setari_oblio: '/api/setari/oblio',
  setari_mechanics: '/api/setari/mechanics',
  setari_statuses: '/api/setari/statuses',
  setari_ramps: '/api/setari/ramps',
  conditii_contract: '/api/conditii-contract',
  reports: '/api/reports',
  haynes: '/api/haynes',
  slack_message: '/api/slack-message',
  log_fe_error: '/api/log-fe-error',
  replay_sessions: '/api/screen-sessions',
  analytics: '/api/analytics'

}
